import { inject, injectable } from 'inversify'
import symbols from '@/symbols'
import {
  FetchAllForexRatesUseCaseInput,
  FetchAllForexRatesUseCaseOutput,
  IAppErrorFactory,
  IFetchAllForexRatesUseCase,
  IForexService,
  IUseCaseOutput,
  IUseCaseOutputFactory,
} from '@/types'

@injectable()
export default class FetchAllForexRatesInteractor implements IFetchAllForexRatesUseCase {
  @inject(symbols.IForexService) private forexService: IForexService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<FetchAllForexRatesUseCaseOutput>

  async handle(input: FetchAllForexRatesUseCaseInput): Promise<IUseCaseOutput<FetchAllForexRatesUseCaseOutput>> {
    const output = this.outputFactory.create({
      defaultValue: {
        forexRates: [],
      },
    })
    try {
      output.data.forexRates = await this.forexService.fetchForexRates(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
